import { WP_URL } from 'config';
import { useSelector } from 'react-redux';
import { RootState } from 'types';

export const camelToSnakeCase = (str: string): string => {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};

export const snakeToCamelCase = (str: string): string => {
  return str.replace(/([-_][a-z])/g, group =>
    group
      .toUpperCase()
      .replace('-', '')
      .replace('_', ''),
  );
};

export const goToWP = (url: string) => {
  const country = localStorage.getItem('country') || 'us';
  const urlPart = (country && country.toLowerCase() === 'us') ? '' : `${country.toLowerCase()}/`;
  window.location.href = `${WP_URL + urlPart + url}`;
};

export const getCurrencySymbol = (
  currencyType?: 'aud' | 'eur' | 'gbp' | 'usd',
  type?: 'aud' | 'eur' | 'gbp' | 'usd',
) => {
  switch (type ? type : currencyType) {
    case 'aud':
      return {
        icon: '\u0024',
        name: 'aud'
      };
    case 'eur':
      return {
        icon: '\u20AC',
        name: 'eur'
      };
    case 'gbp':
      return {
        icon: '\u00A3',
        name: 'gbp'
      };
      case 'usd':
        return {
          icon: '\u0024',
          name: 'usd'
        };
    default:
      return {
        icon: '',
        name: ''
      };
  }
};
